import { render, staticRenderFns } from "./deleteOrgRelStaff.vue?vue&type=template&id=96898510&scoped=true"
import script from "./deleteOrgRelStaff.vue?vue&type=script&lang=js"
export * from "./deleteOrgRelStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteOrgRelStaff.vue?vue&type=style&index=0&id=96898510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96898510",
  null
  
)

export default component.exports